<template>
  <div class="left-main">
    <div class="left-main-top">
      <div class="item-con"  @click="handleItemClick('task')" :class="{'itemActive': activeName === 'task'}">
        <img src="../../assets/left_images/task.png" alt="" size="24" />
        <span class="title">任务栏</span>
      </div>
      <div class="item-con" @click="handleItemClick('notice')" :class="{'itemActive': activeName === 'notice'}">
        <img src="../../assets/left_images/notice.png" alt="" size="24" />
        <span class="title">消息</span>
      </div>
      <div class="item-con" @click="handleItemClick('user')" :class="{'itemActive': activeName === 'user'}">
        <!-- <img src="../../assets/left_images/user.png" alt="" size="24" />
        <span class="title">{{ name }}</span> -->
        <el-popover
          placement="right"
          width="218px"
          trigger="click">
          <div>
            <div class="logo-con">
              <img src="../../assets/user.png" alt="" style="width: 40px;height: 40px;" />
              <div class="logo-font">
                <p style="margin: 0;font-size: 14px;color: #333333;line-height: 14px;font-weight: 500;">你好，{{ userInfo.account }}</p>
                <p style="margin: 0;margin-top: 4px;font-size: 12px;color: #666666;line-height: 16px;">欢迎使用综合服务平台</p>
              </div>
            </div>
            <div class="user-mes">
              <p class="user-mes">
                企业名称：{{ companyName }}
                <el-button v-if="userInfo.role === '1'" type="text" size="mini" icon="el-icon-refresh" @click="handleSwitchEnterprise" style="padding: 0; margin-left: 5px; color: #2674B4;">切换</el-button>
              </p>
              <p class="user-mes">所属角色：{{ userInfo.role==="1"?"主场 / 主运":"展商 / 搭建商" }}</p>
              <!-- <p class="user-mes">创建日期：{{ addDate }}</p> -->
            </div>
            <div class="btn-con">
              <el-button type="default" plain @click="showChangePwd = true">修改密码</el-button>
              <el-button type="default" @click="logout" plain>退出登录</el-button>
            </div>
          </div>
          <el-button slot="reference">
            <img src="../../assets/left_images/user.png" alt="" size="24" />
            <p class="title">账号</p>
          </el-button>
        </el-popover>

      </div>
    </div>
    <div class="left-main-bottom">
      <div class="item-con" @click="handleItemClick('version')" :class="{'itemActive': activeName === 'version'}">
        <img src="../../assets/left_images/version.png" alt="" size="24" />
        <span class="title">版本号</span>
      </div>
    </div>
    <!--操作记录弹框-->
    <div v-show="showRecord" class="record-list">
      <div class="record-title">
        <span>操作记录</span>
        <img
          src="../../assets/left_images/close.png"
          alt=""
          size="24"
          class="closeBtn"
          @click="showRecord=false"
        />
      </div>
      <div v-for="tag in visitedViews" class="record-item" :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
      >
        <router-link
          ref="tag"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          {{ generateTitle(tag.title) }}
          <span
            v-if="!isAffix(tag)"
            class="el-icon-close"
            @click.prevent.stop="closeSelectedTag(tag)"
          />
        </router-link>
      </div>
    </div>
      <!--修改密码-->
      <el-dialog
      title="修改密码"
      :visible.sync="showChangePwd"
      width="528px"
      :before-close="handleClose"
       :close-on-click-modal="false"
      class="pwdDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model.trim="filteredOldPassword"  show-password maxlength="20" @input="handleInput"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model.trim="filteredNewPassword" maxlength="20" show-password @input="handleNewPwd"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model.trim="filteredConfirmPassword" show-password maxlength="20" @input="handleConfirmPwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="margin-top: 0px;">
        <el-button type="default" @click="handleClose()" plain>取 消</el-button>
        <el-button type="primary" @click="handleSubmitChange()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 切换企业弹框 -->
    <SwitchEnterpriseDialog ref="switchEnterpriseDialog" @switch-success="onSwitchSuccess" />
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import { generateTitle } from "@/utils/i18n";
import { clearAllCookies } from "@/utils/auth";
import path from "path";
import { md5 } from "js-md5";
import { userUpdateOneselfPwd } from "@/api/user";
import SwitchEnterpriseDialog from "./SwitchEnterpriseDialog.vue";

export default {
  components: {
    SwitchEnterpriseDialog
  },
  data() {
    // 自定义密码规则验证
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 8) {
        callback(new Error('密码长度不能少于8位'));
      } else if (
        !/[A-Z]/.test(value) ||
        !/[a-z]/.test(value) ||
        !/[0-9]/.test(value) ||
        !/[^A-Za-z0-9]/.test(value)
      ) {
        callback(
          new Error('密码必须包含大写字母、小写字母、数字和特殊字符')
        );
      } else {
        callback();
      }
    };
    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      showRecord: false,
      activeName:'',
      showChangePwd: false, //显示修改密码弹框
      ruleForm:{
        oldPassword: '',
        password: '',
        confirmPassword: '',
      },
      rules:{
        oldPassword:[
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        password:[
          { required: true, validator: validatePassword, trigger: 'blur' },
        ],
        confirmPassword:[
          // { required: true, message: '请确认密码', trigger: 'blur' },
          // { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
          { required: true, validator: validateConfirmPassword, trigger: 'blur' },
        ]
      },
      userInfo:{},
      companyName: '',
    };
  },
  created(){
    // console.log(">>>>created--leftMain--this.userInfo",this.userInfo);
    this.$nextTick(()=>{
      
    })
    setTimeout(() => {
      this.companyName = localStorage.getItem('companyName') || ''
    },1000)
  },
  mounted() {
    // console.log("》》》》mounted--leftMain--this.userInfo",this.userInfo);
  },
  computed: {
    ...mapGetters([
      "name",
      // "userInfo",
    ]),
    visitedViews() {
      console.log(this.$store.state.tagsView.visitedViews);
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      return this.$store.state.permission.routes;
    },
    filteredOldPassword: {
      get() {
        return this.ruleForm.oldPassword;
      },
      set(value) {
        // 过滤输入内容，只允许数字、字母和特定特殊字符
        this.ruleForm.oldPassword = value.replace(
          /[^0-9a-zA-Z`~!@#$%^&*()-_=+\[\]{}\|;:<.>/?]/g,
          ''
        );
      },
    },
    filteredNewPassword: {
      get() {
        return this.ruleForm.password;
      },
      set(value) {
        // 过滤输入内容，只允许数字、字母和特定特殊字符
        this.ruleForm.password = value.replace(
          /[^0-9a-zA-Z`~!@#$%^&*()-_=+\[\]{}\|;:<.>/?]/g,
          ''
        );
      },
    },
    filteredConfirmPassword: {
      get() {
        return this.ruleForm.confirmPassword;
      },
      set(value) {
        // 过滤输入内容，只允许数字、字母和特定特殊字符
        this.ruleForm.confirmPassword = value.replace(
          /[^0-9a-zA-Z`~!@#$%^&*()-_=+\[\]{}\|;:<.>/?]/g,
          ''
        );
      },
    },
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    this.initTags()
    this.addTags()
  },
  methods: {
    generateTitle, // generateTitle by vue-i18n
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = [];
      routes.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch("tagsView/addVisitedView", tag);
        }
      }
    },
    addTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane && this.$refs.scrollPane.moveToTarget(tag);
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("tagsView/updateVisitedView", this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch("tagsView/delCachedView", view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: "/redirect" + fullPath,
          });
        });
      });
    },
    closeSelectedTag(view) {
      this.$store
        .dispatch("tagsView/delView", view)
        .then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews, view);
          }
        });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store
        .dispatch("tagsView/delOthersViews", this.selectedTag)
        .then(() => {
          this.moveToCurrentTag();
        });
    },
    closeAllTags(view) {
      this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
        if (this.affixTags.some((tag) => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "Dashboard") {
          // to reload home page
          this.$router.replace({ path: "/redirect" + view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    },
    handleItemClick(name) {
        this.activeName = name
        this.showRecord = false
        if(name=='task') {
            this.showRecord = true
        }
        // 打开用户信息弹框时，需要重新获取公司名称
        if(name=='user') {
          this.companyName = localStorage.getItem('companyName') || ''
        }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      clearAllCookies()
    },
    //关闭修改密码弹框
    handleClose(){
      this.$refs.ruleForm.resetFields()
      this.$refs.ruleForm.clearValidate()
      this.showChangePwd = false
    },
    //提交密码修改
    handleSubmitChange(){
      this.$refs.ruleForm.validate(valid => {
        if(valid){
          userUpdateOneselfPwd({
            confirmPassword: md5(this.ruleForm.confirmPassword),
            oldPassword: md5(this.ruleForm.oldPassword),
            password: md5(this.ruleForm.password),
          }).then(res => {
            this.$message.success('修改成功')
            this.handleClose()
          })
        }
      })
    },
    handleInput(value) {
      // 更新 filteredPassword，触发 computed 的 setter
      this.filteredOldPassword = value;
    },
    handleNewPwd(value) {
      // 更新 filteredPassword，触发 computed 的 setter
      this.filteredNewPassword = value;
    },
    handleConfirmPwd(value) {
      // 更新 filteredPassword，触发 computed 的 setter
      this.filteredConfirmPassword = value;
    },
    handleSwitchEnterprise() {
      // document.body.click(); // Close the popover
      this.$refs.switchEnterpriseDialog.open(this.companyName);
    },
    onSwitchSuccess(companyName) {
      this.companyName = companyName;
      localStorage.setItem('companyName', companyName);
      if (this.$route.path !== '/home/index') {
        this.$router.push('/home/index');
      } else {
        window.location.reload();
      }
    }
  },
};
</script>
<style scoped lang="scss">
.left-main {
  width: 60px;
  background-image: linear-gradient(0deg, #ebf2f8 7%, #e7eff7 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-con {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 86px;
  cursor: pointer;
}
.itemActive{
    background: #f3f8fb;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title {
  margin-top: 10px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666666;
  text-align: center;
  line-height: 12px;
  font-weight: 400;
}
.record-list {
  width: 230px;
  position: absolute;
  padding: 22px;
  top: 0;
  left: 58px;
  height: 100%;
  background: #f3f8fb;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: 999;
}
.tags-view-item{
  font-size:14px;
  position: relative;
  width: 100%;
  display: inline-block;
  .el-icon-close{
    position: absolute;
    right: 15px;
    top: 1px;
    display: none;
  }
  &:hover{
    .el-icon-close{
      display: block;
    }
  }
}
.record-item {
  margin-top: 24px; 
  cursor: pointer;
  padding-left:10px;
}
.record-item.active {
  color: #2674b4;
  background: #ffffff;
  border-radius: 8px;
  padding: 9px 0;
  padding-left:10px;
}
.record-title {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  font-weight: 500;
  position: relative;
}
.closeBtn {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
}
.el-button{
  background: transparent;
  border-style: none;
}

.logo-con{
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-left: 4px;
  img{
    margin-right: 10px;
    width: 40px;
    height: 40px;
  }
}
.user-mes{
  margin-top: 20px;
  padding-left: 4px;
  p{
    margin: 0;
    margin-bottom: 10px;
    font-size: 12px;
    color: #999999;
    line-height: 12px;
    font-weight: 400;
    max-width: 500px;
    word-break: break-all;
  }
}
.btn-con{
  margin-top: 22px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  ::v-deep .el-button{
    border: 1px solid #DCDFE6;
  }
}
.pwdDialog{
  ::v-deep .el-dialog__body{
    padding-bottom: 0px;
  }
  ::v-deep .el-dialog__footer{
    padding-bottom: 24px;
    padding-top: 0px;
    .el-button{
      border: 1px solid #2674b4;
      background: transparent;
      &.el-button--primary{
        background-image:-webkit-gradient(linear, left top, right top, color-stop(14%, #2674B4), color-stop(86%, #3D84BD))
      }
      &.is-plain{
        &:hover{
          background-image:-webkit-gradient(linear, left top, right top, color-stop(14%, #2674B4), color-stop(86%, #3D84BD))
        }
      }
    }
  }
}
</style>
  